import { Routes, Route, Link, Navigate } from 'react-router-dom';
import { useAuth } from './hooks/useAuth';
import { TopPage } from './pages/TopPage';
import { GameDetailPage } from './pages/GameDetailPage';
import { GameFormPage } from './pages/GameFormPage';
import { KeywordHistoryPage } from './pages/KeywordHistoryPage';
import { AiAnalyzePage } from './pages/AiAnalyzePage';
import { AccessDeniedPage } from './pages/AccessDeniedPage';

export default function App() {
  const status = useAuth();

  if (status.phase === 'loading') {
    return (
      <div className="signin-page">
        <div className="signin-card">読み込み中…</div>
      </div>
    );
  }
  if (status.phase === 'denied') {
    return <AccessDeniedPage message={status.message} />;
  }

  return (
    <>
      <header className="top">
        <h1>
          <Link to="/" style={{ color: 'inherit' }}>SEO Keyword Dashboard</Link>
        </h1>
        <div className="user">
          <span className="muted">session: {status.user.uid.slice(0, 8)}</span>
        </div>
      </header>
      <main className="container">
        <Routes>
          <Route path="/" element={<TopPage />} />
          <Route path="/games/new" element={<GameFormPage mode="create" />} />
          <Route path="/games/:gameId" element={<GameDetailPage />} />
          <Route path="/games/:gameId/edit" element={<GameFormPage mode="edit" />} />
          <Route path="/games/:gameId/history/:language/:keyword" element={<KeywordHistoryPage />} />
          <Route path="/games/:gameId/analyze/:language" element={<AiAnalyzePage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </>
  );
}
